import Vue from 'vue'
import 'normalize.css/normalize.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'
import { GET_OSS_URL,ossFileURL } from '@/utils/utils'
import '@/styles/index.scss'
import * as currency from '@/utils/utils'

import App from './App'
import store from './store'
import router from './router'
import * as api from './api/index'
import "@/assets/iconfont/iconfont.css"
import '@/icons'
import '@/permission'
import '@/directive/autoScroll'
import StickyTop from '@/components/sticky-top/sticky-top';
import search from "@/components/search/lin-search";
import Back from "@/components/Back/Back";
import countTo from 'vue-count-to'
import Keyboard from "@/components/keyboard/keyboard";
import fullScreenContainer from "./components/dv-full-screen/dv-full-screen"

Vue.use(ElementUI)

Vue.component('dvFullScreenContainer', fullScreenContainer)
Vue.component('s-sticky-top', StickyTop)
Vue.component("s-search", search);
Vue.component("back", Back);
Vue.use(countTo)
Vue.component('countTo', countTo)
Vue.component("s-Keyboard", Keyboard);
//全局配置el-dialog点击遮罩层不关闭
ElementUI.Dialog.props.closeOnClickModal.default = false

Vue.config.productionTip = false
Vue.prototype.$OSSURL = ossFileURL
Vue.prototype.$currency = currency
Vue.prototype.$api = api

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
